module.exports = __webpack_public_path__ + "static/media/leica.8a8f330f.jpg";